import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// components
import { Select } from '../static/Select';
// functions
import { findOption } from 'functions/selects';

class AchievementTaskSelect extends Component {

  static propTypes = {
    onChange: PropTypes.func,
    filter: PropTypes.func,
    value: PropTypes.any,
    showMiles: PropTypes.bool
  }

  static defaultProps = {
    showMiles: false
  }

  getOptions = () => {
    let { tasks, filter, subjectId } = this.props;

    if ( filter ) {
      tasks = tasks.filter( filter );
    }

    if ( subjectId ) {
      tasks = tasks.filter( task => task.subject_id === subjectId );
    }
    
    return tasks.map( task => ({
      value: task.achievement_task_id, 
      label: this.getLabel( task )
    }));
  }

  getLabel = ({ task, points }) => {
    const { showMiles } = this.props;
    if ( showMiles ) {
      return (
        <span>
          <span className='hebrew'>{ task }</span> ({ points } miles)
        </span>
      );
    }
    return task;
  }
  
  render() {
    const { value, loading } = this.props;

    let options = this.getOptions();
    let selected = findOption( options, value ) || null;

    return (
      <Select
        {...this.props}
        value={ selected }
        options={ options }
        isLoading={ loading } />
    );
  }
}

const mapStateToProps = ({ rewards }) => {
  return { ...rewards.achievement_tasks };
}

export default connect( mapStateToProps )( AchievementTaskSelect );



// WEBPACK FOOTER //
// ./src/components/selects/redux/AchievementTaskSelect.jsx